{
  "aiGeneratedAnswer": "Ответ, сгенерированный ИИ",
  "allCategories": "Все категории",
  "appliedFiltersToCurrentSearch": "Применённые фильтры к текущему поиску",
  "apply": "Применить",
  "applyFilters": "Применить фильтры",
  "autocompleteOptionsFound_few": "Найдены {{count}} автозаполняющие опции {{label}}.",
  "autocompleteOptionsFound_many": "Найдено {{count}} автозаполняющих опций {{label}}.",
  "autocompleteOptionsFound_one": "Найдена {{count}} автозаполняющая опция {{label}}.",
  "autocompleteOptionsFound_other": "Найдено {{count}} автозаполняющих опций {{label}}.",
  "autocompleteSuggestion": "Подсказка автозаполнения: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Найдены {{count}} подсказки автозаполнения.",
  "autocompleteSuggestionsFound_many": "Найдено {{count}} подсказок автозаполнения.",
  "autocompleteSuggestionsFound_one": "Найдена {{count}} подсказка автозаполнения.",
  "autocompleteSuggestionsFound_other": "Найдено {{count}} подсказок автозаполнения.",
  "basedOnYourDevice": " (на основе вашего устройства)",
  "basedOnYourInternetAddress": " (на основе вашего интернет-адреса)",
  "categoriesText_few": "В категориях — <strong>{{query}}</strong> найдены результаты",
  "categoriesText_many": "В категориях — <strong>{{query}}</strong> найдено результатов",
  "categoriesText_one": "В категории — <strong>{{query}}</strong> найден результат",
  "categoriesText_other": "В категориях — <strong>{{query}}</strong> найдено результатов",
  "clearAll": "Очистить всё",
  "clearMinAndMax": "Очистить минимальное и максимальное значения",
  "clearTheRangeToSelectOptions": "Очистите диапазон для выбора опций.",
  "clearTheSearchBar": "Очистить строку поиска",
  "conductASearch": "Выполнить поиск",
  "currentLocation": "Текущее местоположение",
  "didYouMean": "Вы имели в виду <button>{{correctedQuery}}</button>?",
  "dropDownScreenReaderInstructions": "Когда доступны результаты автозаполнения, используйте стрелки вверх и вниз для просмотра и Enter для выбора.",
  "feedback": "Обратная связь",
  "invalidRange": "Недопустимый диапазон",
  "max": "Макс",
  "min": "Мин",
  "navigateToTheNextResultsPage": "Перейти к следующей странице результатов",
  "navigateToThePreviousResultsPage": "Перейти к предыдущей странице результатов",
  "noAutocompleteOptionsFound": "Автозаполняющих опций не найдено.",
  "noAutocompleteSuggestionsFound": "Подсказок автозаполнения не найдено.",
  "noResultsFoundIn": "Результатов не найдено в {{currentVerticalLabel}}.",
  "pagination": "Пагинация",
  "readMoreAbout": "Подробнее о <a>{{name}}</a>",
  "recentSearch": "недавний поиск: {{query}}",
  "recentSearchesFound_few": "Найдены {{count}} недавних поиска.",
  "recentSearchesFound_many": "Найдено {{count}} недавних поисков.",
  "recentSearchesFound_one": "Найдён {{count}} недавний поиск.",
  "recentSearchesFound_other": "Найдено {{count}} недавних поисков.",
  "removeFilter": "Удалить фильтр «{{displayName}}»",
  "resultPreview": "Превью результата: {{value}}",
  "resultPreviewsFound_few": "Найдены {{count}} предварительных просмотра.",
  "resultPreviewsFound_many": "Найдено {{count}} предварительных просмотров.",
  "resultPreviewsFound_one": "Найдён {{count}} предварительный просмотр.",
  "resultPreviewsFound_other": "Найдено {{count}} предварительных просмотров.",
  "resultsCountText_few": "{{count}} результата",
  "resultsCountText_many": "{{count}} результатов",
  "resultsCountText_one": "{{count}} результат",
  "resultsCountText_other": "{{count}} результата",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} из {{resultsCount}} результатов",
  "searchHere": "Искать здесь…",
  "showLess": "Показать меньше",
  "showMore": "Показать больше",
  "showingAllInstead": "Показаны все {{currentVerticalLabel}} вместо этого.",
  "sources_few": "Источника ({{count}})",
  "sources_many": "Источников ({{count}})",
  "sources_one": "Источник",
  "sources_other": "Источника ({{count}})",
  "submitSearch": "Отправить поиск",
  "suggestionResultsCount_few": "{{label}} - {{count}} результата",
  "suggestionResultsCount_many": "{{label}} - {{count}} результатов",
  "suggestionResultsCount_one": "{{label}} - {{count}} результат",
  "suggestionResultsCount_other": "{{label}} - {{count}} результата",
  "thankYouForYourFeedback": "Спасибо за ваш отзыв!",
  "thisAnsweredMyQuestion": "Это ответило на мой вопрос",
  "thisDidNotAnswerMyQuestion": "Это не ответило на мой вопрос",
  "unselectAnOptionToEnterInARange": "Снимите выбор опции, чтобы ввести диапазон.",
  "updateYourLocation": "Обновить ваше местоположение",
  "useCurrentLocation": "Использовать текущее местоположение",
  "useMyLocation": "Использовать моё местоположение",
  "viewAll": "Показать все",
  "viewDetails": "Просмотреть детали"
}
